import { type Writable, writable } from 'svelte/store';

export const menuStore: Writable<{ hasUnreadMessages: boolean | null }> = writable({ hasUnreadMessages: null });
